export default __webpack_public_path__ + "132985148ae9944e997360a430c9a2b5.svg";